const ServerAction = require('./ServerAction');

module.exports = ServerAction.extend({
    isApplicable: function (objs) {
      if (typeof objs === "undefined") {return false;}
      let applicable = true;
      
      return applicable;
    }
  });